/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Cron_HintInputs */



/**
* | output |
* | --- |
* | "Standard 5-field cron. Fires no more often than every 15 minutes." |
*
* @param {Agent_Schedule_Cron_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_cron_hint = /** @type {((inputs?: Agent_Schedule_Cron_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Cron_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standard-Cron mit 5 Feldern. Läuft höchstens alle 15 Minuten.")
	return /** @type {LocalizedString} */ ("Standard 5-field cron. Fires no more often than every 15 minutes.")
});